import React from 'react';
import { useParams } from 'react-router-dom';
import { Alert, Typography, Space, Tag } from 'antd';
import { GiftOutlined, UsergroupAddOutlined } from '@ant-design/icons';
import SignUp from './SignUp';
import { useTranslation } from 'react-i18next';

const { Title, Text } = Typography;

const SignUpWithReferral = () => {
  const { referral_code } = useParams();
  const { t } = useTranslation();

  const alertComponent = (
    <div style={{ width: '100%', maxWidth: '1200px', margin: '20px auto' }}>
      <Alert
        message={
          <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            <Title level={5} style={{ margin: 0 }}>
              {t('referrals.sign_up_title')}
            </Title>
          </div>
        }
        description={
          <Space direction="vertical" size={8}>
            <Text style={{ fontSize: '15px' }}>{t('referrals.sign_up_subtitle')}</Text>
          </Space>
        }
        type="info"
        showIcon
        icon={<GiftOutlined />}
      />
    </div>
  );

  const signupParams = { ref: referral_code };

  return <SignUp signupParams={signupParams} alertComponent={alertComponent} />;
};

export default SignUpWithReferral;


